// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* SORA2 视频生成节点样式 */

/* 节点容器 */
.Sora2VideoNode-container {
  position: relative;
  background: white;
  border: 2px solid #e5e7eb;
  border-radius: 12px;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1);
  transition: all 0.2s ease;
  min-width: 320px;
}

.Sora2VideoNode-container:hover {
  box-shadow: 0 8px 24px rgba(0, 0, 0, 0.15);
  border-color: #8b5cf6;
}

/* 标题 */
.Sora2VideoNode-title {
  padding: 12px 16px;
  background: linear-gradient(135deg, #8b5cf6 0%, #7c3aed 100%);
  color: white;
  font-weight: 600;
  font-size: 14px;
  border-radius: 10px 10px 0 0;
  text-align: center;
  user-select: none;
}

/* Handle 样式 */
.Sora2VideoNode-handle {
  width: 14px;
  height: 14px;
  border: 2px solid #8b5cf6;
  background: white;
  border-radius: 50%;
  transition: all 0.2s ease;
}

.Sora2VideoNode-handle:hover {
  width: 18px;
  height: 18px;
  border-width: 3px;
}

.Sora2VideoNode-handle-prompt {
  border-color: #667eea;
  background: #667eea;
}

.Sora2VideoNode-handle-image {
  border-color: #48bb78;
  background: #48bb78;
}

.Sora2VideoNode-handle-output {
  border-color: #8b5cf6;
  background: #8b5cf6;
}

/* Handle 标签 */
.Sora2VideoNode-handle-label {
  position: absolute;
  left: -70px;
  top: 50%;
  transform: translateY(-50%);
  background: linear-gradient(135deg, #8b5cf6 0%, #7c3aed 100%);
  color: white;
  padding: 6px 12px;
  border-radius: 16px;
  font-size: 12px;
  font-weight: 600;
  white-space: nowrap;
  pointer-events: none;
  opacity: 0;
  transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
  box-shadow: 0 4px 12px rgba(139, 92, 246, 0.25);
  border: 1px solid rgba(255, 255, 255, 0.2);
  backdrop-filter: blur(8px);
  text-shadow: 0 1px 2px rgba(0, 0, 0, 0.1);
  letter-spacing: 0.025em;
  z-index: 100;
}

/* 可点击的 Handle 标签 */
.Sora2VideoNode-handle-label-clickable {
  pointer-events: auto;
  cursor: pointer;
  user-select: none;
}

.Sora2VideoNode-handle-label-clickable:hover {
  transform: translateY(-50%) translateX(-4px) scale(1.05);
  box-shadow: 0 8px 24px rgba(139, 92, 246, 0.45);
  background: linear-gradient(135deg, #a78bfa 0%, #9333ea 100%);
}

.Sora2VideoNode-handle-label-clickable:active {
  transform: translateY(-50%) translateX(-2px) scale(0.98);
}

.Sora2VideoNode-handle-label-clickable::after {
  content: ' +';
  font-weight: 700;
  margin-left: 4px;
  opacity: 0;
  transition: opacity 0.2s ease;
}

.Sora2VideoNode-handle-label-clickable:hover::after {
  opacity: 1;
}

.Sora2VideoNode-handle:hover .Sora2VideoNode-handle-label {
  opacity: 1;
  transform: translateY(-50%) translateX(-2px);
  box-shadow: 0 6px 20px rgba(139, 92, 246, 0.35);
}

.Sora2VideoNode-handle:hover .Sora2VideoNode-handle-label::before {
  content: '';
  position: absolute;
  right: -4px;
  top: 50%;
  transform: translateY(-50%);
  width: 0;
  height: 0;
  border-left: 4px solid #8b5cf6;
  border-top: 4px solid transparent;
  border-bottom: 4px solid transparent;
  filter: drop-shadow(0 1px 2px rgba(139, 92, 246, 0.2));
}

.Sora2VideoNode-handle-prompt .Sora2VideoNode-handle-label {
  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
  box-shadow: 0 4px 12px rgba(102, 126, 234, 0.25);
}

.Sora2VideoNode-handle-prompt:hover .Sora2VideoNode-handle-label {
  box-shadow: 0 6px 20px rgba(102, 126, 234, 0.35);
}

.Sora2VideoNode-handle-prompt:hover .Sora2VideoNode-handle-label::before {
  border-left-color: #667eea;
  filter: drop-shadow(0 1px 2px rgba(102, 126, 234, 0.2));
}

.Sora2VideoNode-handle-image .Sora2VideoNode-handle-label {
  background: linear-gradient(135deg, #48bb78 0%, #2d7a5f 100%);
  box-shadow: 0 4px 12px rgba(72, 187, 120, 0.25);
}

.Sora2VideoNode-handle-image:hover .Sora2VideoNode-handle-label {
  box-shadow: 0 6px 20px rgba(72, 187, 120, 0.35);
}

.Sora2VideoNode-handle-image:hover .Sora2VideoNode-handle-label::before {
  border-left-color: #48bb78;
  filter: drop-shadow(0 1px 2px rgba(72, 187, 120, 0.2));
}

/* 节点被选中时，一直显示标签 */
.react-flow__node.selected .Sora2VideoNode-handle .Sora2VideoNode-handle-label {
  opacity: 1;
  transform: translateY(-50%) translateX(-2px);
  box-shadow: 0 6px 20px rgba(139, 92, 246, 0.35);
}

.react-flow__node.selected .Sora2VideoNode-handle-prompt .Sora2VideoNode-handle-label {
  box-shadow: 0 6px 20px rgba(102, 126, 234, 0.35);
}

.react-flow__node.selected .Sora2VideoNode-handle-image .Sora2VideoNode-handle-label {
  box-shadow: 0 6px 20px rgba(72, 187, 120, 0.35);
}

/* 标签出现动画 */
@keyframes Sora2VideoNode-labelFadeIn {
  0% {
    opacity: 0;
    transform: translateY(-50%) translateX(-10px);
  }
  100% {
    opacity: 1;
    transform: translateY(-50%) translateX(-2px);
  }
}

.Sora2VideoNode-handle:hover .Sora2VideoNode-handle-label,
.react-flow__node.selected .Sora2VideoNode-handle .Sora2VideoNode-handle-label {
  animation: Sora2VideoNode-labelFadeIn 0.3s cubic-bezier(0.4, 0, 0.2, 1);
}

/* 内容包装器 */
.Sora2VideoNode-wrapper {
  padding: 16px;
  width: 320px;
}

/* 字段容器 */
.Sora2VideoNode-field {
  margin-bottom: 16px;
}

/* 标签 */
.Sora2VideoNode-label {
  display: block;
  margin-bottom: 8px;
  font-weight: 500;
  font-size: 13px;
  color: #374151;
}

/* 下拉选择框 */
.Sora2VideoNode-select {
  width: 100%;
  padding: 10px 12px;
  border: 1px solid #d1d5db;
  border-radius: 8px;
  font-size: 14px;
  background-color: #ffffff;
  color: #1f2937;
  cursor: pointer;
  transition: all 0.2s ease;
}

.Sora2VideoNode-select:hover {
  border-color: #9ca3af;
}

.Sora2VideoNode-select:focus {
  outline: none;
  border-color: #8b5cf6;
  box-shadow: 0 0 0 3px rgba(139, 92, 246, 0.1);
}

.Sora2VideoNode-select:disabled {
  background-color: #f3f4f6;
  cursor: not-allowed;
}

/* 模型信息标签 */
.Sora2VideoNode-info {
  display: flex;
  gap: 8px;
  margin-bottom: 16px;
  flex-wrap: wrap;
}

.Sora2VideoNode-info-badge {
  display: inline-flex;
  align-items: center;
  padding: 4px 10px;
  background-color: #ede9fe;
  color: #6d28d9;
  font-size: 12px;
  font-weight: 500;
  border-radius: 12px;
}

/* 提示信息 */
.Sora2VideoNode-hint {
  padding: 12px;
  background-color: #fef3c7;
  border: 1px solid #fbbf24;
  border-radius: 8px;
  font-size: 12px;
  line-height: 1.6;
  color: #78350f;
  margin-bottom: 16px;
}

/* 生成按钮 */
.Sora2VideoNode-generate {
  width: 100%;
  padding: 12px 20px;
  background: linear-gradient(135deg, #8b5cf6 0%, #7c3aed 100%);
  color: white;
  border: none;
  border-radius: 8px;
  font-size: 14px;
  font-weight: 600;
  cursor: pointer;
  transition: all 0.2s ease;
  box-shadow: 0 2px 8px rgba(139, 92, 246, 0.3);
}

.Sora2VideoNode-generate:hover:not(:disabled) {
  background: linear-gradient(135deg, #7c3aed 0%, #6d28d9 100%);
  box-shadow: 0 4px 12px rgba(139, 92, 246, 0.4);
  transform: translateY(-1px);
}

.Sora2VideoNode-generate:active:not(:disabled) {
  transform: translateY(0);
}

.Sora2VideoNode-generate-disabled {
  background: #d1d5db;
  cursor: not-allowed;
  box-shadow: none;
}

/* 错误提示 */
.Sora2VideoNode-error {
  margin-top: 12px;
  padding: 12px;
  background-color: #fee2e2;
  border: 1px solid #ef4444;
  border-radius: 8px;
  color: #991b1b;
  font-size: 13px;
  line-height: 1.5;
}

/* 参考图片网格展示 */
.Sora2VideoNode-image-grid {
  display: grid;
  grid-template-columns: repeat(4, 1fr);
  gap: 8px;
  margin-top: 8px;
}

.Sora2VideoNode-image-thumb {
  position: relative;
  aspect-ratio: 1;
  border-radius: 6px;
  overflow: hidden;
  border: 2px solid #e5e7eb;
  transition: all 0.2s;
  background: #f9fafb;
}

.Sora2VideoNode-image-thumb:hover {
  border-color: #8b5cf6;
  transform: scale(1.05);
  z-index: 10;
}

.Sora2VideoNode-image-inactive {
  opacity: 0.4;
  filter: grayscale(0.5);
}

.Sora2VideoNode-thumb-img {
  width: 100%;
  height: 100%;
  object-fit: cover;
  display: block;
}

.Sora2VideoNode-thumb-index {
  position: absolute;
  top: 4px;
  right: 4px;
  background: rgba(139, 92, 246, 0.9);
  color: white;
  width: 20px;
  height: 20px;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 10px;
  font-weight: 600;
}

.Sora2VideoNode-thumb-active-badge {
  position: absolute;
  bottom: 4px;
  left: 4px;
  background: rgba(16, 185, 129, 0.95);
  color: white;
  padding: 2px 6px;
  border-radius: 4px;
  font-size: 10px;
  font-weight: 600;
}

/* 警告提示 */
.Sora2VideoNode-warning {
  margin-top: 8px;
  padding: 8px;
  background-color: #fef3c7;
  border: 1px solid #fbbf24;
  border-radius: 6px;
  font-size: 11px;
  color: #78350f;
  line-height: 1.4;
}

/* 复制按钮样式 */
.Sora2VideoNode-duplicate-button {
  position: absolute;
  top: 8px;
  right: 8px;
  width: 28px;
  height: 28px;
  border: 1px solid #ddd;
  border-radius: 6px;
  background: white;
  color: #666;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 14px;
  transition: all 0.2s ease;
  opacity: 0;
  pointer-events: none;
  z-index: 10;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
}

.Sora2VideoNode-container:hover .Sora2VideoNode-duplicate-button {
  opacity: 1;
  pointer-events: auto;
}

.Sora2VideoNode-duplicate-button:hover {
  background: #f0f0f0;
  border-color: #3b82f6;
  color: #3b82f6;
  transform: scale(1.05);
}

.Sora2VideoNode-duplicate-button:active {
  transform: scale(0.95);
}

.react-flow__node.selected .Sora2VideoNode-duplicate-button {
  opacity: 1;
  pointer-events: auto;
}

`, "",{"version":3,"sources":["webpack://./src/components/canvas/nodes/Sora2VideoNode.css"],"names":[],"mappings":"AAAA,mBAAmB;;AAEnB,SAAS;AACT;EACE,kBAAkB;EAClB,iBAAiB;EACjB,yBAAyB;EACzB,mBAAmB;EACnB,yCAAyC;EACzC,yBAAyB;EACzB,gBAAgB;AAClB;;AAEA;EACE,0CAA0C;EAC1C,qBAAqB;AACvB;;AAEA,OAAO;AACP;EACE,kBAAkB;EAClB,6DAA6D;EAC7D,YAAY;EACZ,gBAAgB;EAChB,eAAe;EACf,4BAA4B;EAC5B,kBAAkB;EAClB,iBAAiB;AACnB;;AAEA,cAAc;AACd;EACE,WAAW;EACX,YAAY;EACZ,yBAAyB;EACzB,iBAAiB;EACjB,kBAAkB;EAClB,yBAAyB;AAC3B;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,iBAAiB;AACnB;;AAEA;EACE,qBAAqB;EACrB,mBAAmB;AACrB;;AAEA;EACE,qBAAqB;EACrB,mBAAmB;AACrB;;AAEA;EACE,qBAAqB;EACrB,mBAAmB;AACrB;;AAEA,cAAc;AACd;EACE,kBAAkB;EAClB,WAAW;EACX,QAAQ;EACR,2BAA2B;EAC3B,6DAA6D;EAC7D,YAAY;EACZ,iBAAiB;EACjB,mBAAmB;EACnB,eAAe;EACf,gBAAgB;EAChB,mBAAmB;EACnB,oBAAoB;EACpB,UAAU;EACV,iDAAiD;EACjD,+CAA+C;EAC/C,0CAA0C;EAC1C,0BAA0B;EAC1B,yCAAyC;EACzC,uBAAuB;EACvB,YAAY;AACd;;AAEA,mBAAmB;AACnB;EACE,oBAAoB;EACpB,eAAe;EACf,iBAAiB;AACnB;;AAEA;EACE,wDAAwD;EACxD,+CAA+C;EAC/C,6DAA6D;AAC/D;;AAEA;EACE,wDAAwD;AAC1D;;AAEA;EACE,aAAa;EACb,gBAAgB;EAChB,gBAAgB;EAChB,UAAU;EACV,6BAA6B;AAC/B;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,UAAU;EACV,4CAA4C;EAC5C,+CAA+C;AACjD;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,WAAW;EACX,QAAQ;EACR,2BAA2B;EAC3B,QAAQ;EACR,SAAS;EACT,8BAA8B;EAC9B,iCAAiC;EACjC,oCAAoC;EACpC,sDAAsD;AACxD;;AAEA;EACE,6DAA6D;EAC7D,gDAAgD;AAClD;;AAEA;EACE,gDAAgD;AAClD;;AAEA;EACE,0BAA0B;EAC1B,uDAAuD;AACzD;;AAEA;EACE,6DAA6D;EAC7D,+CAA+C;AACjD;;AAEA;EACE,+CAA+C;AACjD;;AAEA;EACE,0BAA0B;EAC1B,sDAAsD;AACxD;;AAEA,kBAAkB;AAClB;EACE,UAAU;EACV,4CAA4C;EAC5C,+CAA+C;AACjD;;AAEA;EACE,gDAAgD;AAClD;;AAEA;EACE,+CAA+C;AACjD;;AAEA,WAAW;AACX;EACE;IACE,UAAU;IACV,6CAA6C;EAC/C;EACA;IACE,UAAU;IACV,4CAA4C;EAC9C;AACF;;AAEA;;EAEE,uEAAuE;AACzE;;AAEA,UAAU;AACV;EACE,aAAa;EACb,YAAY;AACd;;AAEA,SAAS;AACT;EACE,mBAAmB;AACrB;;AAEA,OAAO;AACP;EACE,cAAc;EACd,kBAAkB;EAClB,gBAAgB;EAChB,eAAe;EACf,cAAc;AAChB;;AAEA,UAAU;AACV;EACE,WAAW;EACX,kBAAkB;EAClB,yBAAyB;EACzB,kBAAkB;EAClB,eAAe;EACf,yBAAyB;EACzB,cAAc;EACd,eAAe;EACf,yBAAyB;AAC3B;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,aAAa;EACb,qBAAqB;EACrB,6CAA6C;AAC/C;;AAEA;EACE,yBAAyB;EACzB,mBAAmB;AACrB;;AAEA,WAAW;AACX;EACE,aAAa;EACb,QAAQ;EACR,mBAAmB;EACnB,eAAe;AACjB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,iBAAiB;EACjB,yBAAyB;EACzB,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA,SAAS;AACT;EACE,aAAa;EACb,yBAAyB;EACzB,yBAAyB;EACzB,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,mBAAmB;AACrB;;AAEA,SAAS;AACT;EACE,WAAW;EACX,kBAAkB;EAClB,6DAA6D;EAC7D,YAAY;EACZ,YAAY;EACZ,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,eAAe;EACf,yBAAyB;EACzB,6CAA6C;AAC/C;;AAEA;EACE,6DAA6D;EAC7D,8CAA8C;EAC9C,2BAA2B;AAC7B;;AAEA;EACE,wBAAwB;AAC1B;;AAEA;EACE,mBAAmB;EACnB,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA,SAAS;AACT;EACE,gBAAgB;EAChB,aAAa;EACb,yBAAyB;EACzB,yBAAyB;EACzB,kBAAkB;EAClB,cAAc;EACd,eAAe;EACf,gBAAgB;AAClB;;AAEA,aAAa;AACb;EACE,aAAa;EACb,qCAAqC;EACrC,QAAQ;EACR,eAAe;AACjB;;AAEA;EACE,kBAAkB;EAClB,eAAe;EACf,kBAAkB;EAClB,gBAAgB;EAChB,yBAAyB;EACzB,oBAAoB;EACpB,mBAAmB;AACrB;;AAEA;EACE,qBAAqB;EACrB,sBAAsB;EACtB,WAAW;AACb;;AAEA;EACE,YAAY;EACZ,sBAAsB;AACxB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,iBAAiB;EACjB,cAAc;AAChB;;AAEA;EACE,kBAAkB;EAClB,QAAQ;EACR,UAAU;EACV,mCAAmC;EACnC,YAAY;EACZ,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,SAAS;EACT,oCAAoC;EACpC,YAAY;EACZ,gBAAgB;EAChB,kBAAkB;EAClB,eAAe;EACf,gBAAgB;AAClB;;AAEA,SAAS;AACT;EACE,eAAe;EACf,YAAY;EACZ,yBAAyB;EACzB,yBAAyB;EACzB,kBAAkB;EAClB,eAAe;EACf,cAAc;EACd,gBAAgB;AAClB;;AAEA,WAAW;AACX;EACE,kBAAkB;EAClB,QAAQ;EACR,UAAU;EACV,WAAW;EACX,YAAY;EACZ,sBAAsB;EACtB,kBAAkB;EAClB,iBAAiB;EACjB,WAAW;EACX,eAAe;EACf,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,eAAe;EACf,yBAAyB;EACzB,UAAU;EACV,oBAAoB;EACpB,WAAW;EACX,wCAAwC;AAC1C;;AAEA;EACE,UAAU;EACV,oBAAoB;AACtB;;AAEA;EACE,mBAAmB;EACnB,qBAAqB;EACrB,cAAc;EACd,sBAAsB;AACxB;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,UAAU;EACV,oBAAoB;AACtB","sourcesContent":["/* SORA2 视频生成节点样式 */\n\n/* 节点容器 */\n.Sora2VideoNode-container {\n  position: relative;\n  background: white;\n  border: 2px solid #e5e7eb;\n  border-radius: 12px;\n  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1);\n  transition: all 0.2s ease;\n  min-width: 320px;\n}\n\n.Sora2VideoNode-container:hover {\n  box-shadow: 0 8px 24px rgba(0, 0, 0, 0.15);\n  border-color: #8b5cf6;\n}\n\n/* 标题 */\n.Sora2VideoNode-title {\n  padding: 12px 16px;\n  background: linear-gradient(135deg, #8b5cf6 0%, #7c3aed 100%);\n  color: white;\n  font-weight: 600;\n  font-size: 14px;\n  border-radius: 10px 10px 0 0;\n  text-align: center;\n  user-select: none;\n}\n\n/* Handle 样式 */\n.Sora2VideoNode-handle {\n  width: 14px;\n  height: 14px;\n  border: 2px solid #8b5cf6;\n  background: white;\n  border-radius: 50%;\n  transition: all 0.2s ease;\n}\n\n.Sora2VideoNode-handle:hover {\n  width: 18px;\n  height: 18px;\n  border-width: 3px;\n}\n\n.Sora2VideoNode-handle-prompt {\n  border-color: #667eea;\n  background: #667eea;\n}\n\n.Sora2VideoNode-handle-image {\n  border-color: #48bb78;\n  background: #48bb78;\n}\n\n.Sora2VideoNode-handle-output {\n  border-color: #8b5cf6;\n  background: #8b5cf6;\n}\n\n/* Handle 标签 */\n.Sora2VideoNode-handle-label {\n  position: absolute;\n  left: -70px;\n  top: 50%;\n  transform: translateY(-50%);\n  background: linear-gradient(135deg, #8b5cf6 0%, #7c3aed 100%);\n  color: white;\n  padding: 6px 12px;\n  border-radius: 16px;\n  font-size: 12px;\n  font-weight: 600;\n  white-space: nowrap;\n  pointer-events: none;\n  opacity: 0;\n  transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);\n  box-shadow: 0 4px 12px rgba(139, 92, 246, 0.25);\n  border: 1px solid rgba(255, 255, 255, 0.2);\n  backdrop-filter: blur(8px);\n  text-shadow: 0 1px 2px rgba(0, 0, 0, 0.1);\n  letter-spacing: 0.025em;\n  z-index: 100;\n}\n\n/* 可点击的 Handle 标签 */\n.Sora2VideoNode-handle-label-clickable {\n  pointer-events: auto;\n  cursor: pointer;\n  user-select: none;\n}\n\n.Sora2VideoNode-handle-label-clickable:hover {\n  transform: translateY(-50%) translateX(-4px) scale(1.05);\n  box-shadow: 0 8px 24px rgba(139, 92, 246, 0.45);\n  background: linear-gradient(135deg, #a78bfa 0%, #9333ea 100%);\n}\n\n.Sora2VideoNode-handle-label-clickable:active {\n  transform: translateY(-50%) translateX(-2px) scale(0.98);\n}\n\n.Sora2VideoNode-handle-label-clickable::after {\n  content: ' +';\n  font-weight: 700;\n  margin-left: 4px;\n  opacity: 0;\n  transition: opacity 0.2s ease;\n}\n\n.Sora2VideoNode-handle-label-clickable:hover::after {\n  opacity: 1;\n}\n\n.Sora2VideoNode-handle:hover .Sora2VideoNode-handle-label {\n  opacity: 1;\n  transform: translateY(-50%) translateX(-2px);\n  box-shadow: 0 6px 20px rgba(139, 92, 246, 0.35);\n}\n\n.Sora2VideoNode-handle:hover .Sora2VideoNode-handle-label::before {\n  content: '';\n  position: absolute;\n  right: -4px;\n  top: 50%;\n  transform: translateY(-50%);\n  width: 0;\n  height: 0;\n  border-left: 4px solid #8b5cf6;\n  border-top: 4px solid transparent;\n  border-bottom: 4px solid transparent;\n  filter: drop-shadow(0 1px 2px rgba(139, 92, 246, 0.2));\n}\n\n.Sora2VideoNode-handle-prompt .Sora2VideoNode-handle-label {\n  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);\n  box-shadow: 0 4px 12px rgba(102, 126, 234, 0.25);\n}\n\n.Sora2VideoNode-handle-prompt:hover .Sora2VideoNode-handle-label {\n  box-shadow: 0 6px 20px rgba(102, 126, 234, 0.35);\n}\n\n.Sora2VideoNode-handle-prompt:hover .Sora2VideoNode-handle-label::before {\n  border-left-color: #667eea;\n  filter: drop-shadow(0 1px 2px rgba(102, 126, 234, 0.2));\n}\n\n.Sora2VideoNode-handle-image .Sora2VideoNode-handle-label {\n  background: linear-gradient(135deg, #48bb78 0%, #2d7a5f 100%);\n  box-shadow: 0 4px 12px rgba(72, 187, 120, 0.25);\n}\n\n.Sora2VideoNode-handle-image:hover .Sora2VideoNode-handle-label {\n  box-shadow: 0 6px 20px rgba(72, 187, 120, 0.35);\n}\n\n.Sora2VideoNode-handle-image:hover .Sora2VideoNode-handle-label::before {\n  border-left-color: #48bb78;\n  filter: drop-shadow(0 1px 2px rgba(72, 187, 120, 0.2));\n}\n\n/* 节点被选中时，一直显示标签 */\n.react-flow__node.selected .Sora2VideoNode-handle .Sora2VideoNode-handle-label {\n  opacity: 1;\n  transform: translateY(-50%) translateX(-2px);\n  box-shadow: 0 6px 20px rgba(139, 92, 246, 0.35);\n}\n\n.react-flow__node.selected .Sora2VideoNode-handle-prompt .Sora2VideoNode-handle-label {\n  box-shadow: 0 6px 20px rgba(102, 126, 234, 0.35);\n}\n\n.react-flow__node.selected .Sora2VideoNode-handle-image .Sora2VideoNode-handle-label {\n  box-shadow: 0 6px 20px rgba(72, 187, 120, 0.35);\n}\n\n/* 标签出现动画 */\n@keyframes Sora2VideoNode-labelFadeIn {\n  0% {\n    opacity: 0;\n    transform: translateY(-50%) translateX(-10px);\n  }\n  100% {\n    opacity: 1;\n    transform: translateY(-50%) translateX(-2px);\n  }\n}\n\n.Sora2VideoNode-handle:hover .Sora2VideoNode-handle-label,\n.react-flow__node.selected .Sora2VideoNode-handle .Sora2VideoNode-handle-label {\n  animation: Sora2VideoNode-labelFadeIn 0.3s cubic-bezier(0.4, 0, 0.2, 1);\n}\n\n/* 内容包装器 */\n.Sora2VideoNode-wrapper {\n  padding: 16px;\n  width: 320px;\n}\n\n/* 字段容器 */\n.Sora2VideoNode-field {\n  margin-bottom: 16px;\n}\n\n/* 标签 */\n.Sora2VideoNode-label {\n  display: block;\n  margin-bottom: 8px;\n  font-weight: 500;\n  font-size: 13px;\n  color: #374151;\n}\n\n/* 下拉选择框 */\n.Sora2VideoNode-select {\n  width: 100%;\n  padding: 10px 12px;\n  border: 1px solid #d1d5db;\n  border-radius: 8px;\n  font-size: 14px;\n  background-color: #ffffff;\n  color: #1f2937;\n  cursor: pointer;\n  transition: all 0.2s ease;\n}\n\n.Sora2VideoNode-select:hover {\n  border-color: #9ca3af;\n}\n\n.Sora2VideoNode-select:focus {\n  outline: none;\n  border-color: #8b5cf6;\n  box-shadow: 0 0 0 3px rgba(139, 92, 246, 0.1);\n}\n\n.Sora2VideoNode-select:disabled {\n  background-color: #f3f4f6;\n  cursor: not-allowed;\n}\n\n/* 模型信息标签 */\n.Sora2VideoNode-info {\n  display: flex;\n  gap: 8px;\n  margin-bottom: 16px;\n  flex-wrap: wrap;\n}\n\n.Sora2VideoNode-info-badge {\n  display: inline-flex;\n  align-items: center;\n  padding: 4px 10px;\n  background-color: #ede9fe;\n  color: #6d28d9;\n  font-size: 12px;\n  font-weight: 500;\n  border-radius: 12px;\n}\n\n/* 提示信息 */\n.Sora2VideoNode-hint {\n  padding: 12px;\n  background-color: #fef3c7;\n  border: 1px solid #fbbf24;\n  border-radius: 8px;\n  font-size: 12px;\n  line-height: 1.6;\n  color: #78350f;\n  margin-bottom: 16px;\n}\n\n/* 生成按钮 */\n.Sora2VideoNode-generate {\n  width: 100%;\n  padding: 12px 20px;\n  background: linear-gradient(135deg, #8b5cf6 0%, #7c3aed 100%);\n  color: white;\n  border: none;\n  border-radius: 8px;\n  font-size: 14px;\n  font-weight: 600;\n  cursor: pointer;\n  transition: all 0.2s ease;\n  box-shadow: 0 2px 8px rgba(139, 92, 246, 0.3);\n}\n\n.Sora2VideoNode-generate:hover:not(:disabled) {\n  background: linear-gradient(135deg, #7c3aed 0%, #6d28d9 100%);\n  box-shadow: 0 4px 12px rgba(139, 92, 246, 0.4);\n  transform: translateY(-1px);\n}\n\n.Sora2VideoNode-generate:active:not(:disabled) {\n  transform: translateY(0);\n}\n\n.Sora2VideoNode-generate-disabled {\n  background: #d1d5db;\n  cursor: not-allowed;\n  box-shadow: none;\n}\n\n/* 错误提示 */\n.Sora2VideoNode-error {\n  margin-top: 12px;\n  padding: 12px;\n  background-color: #fee2e2;\n  border: 1px solid #ef4444;\n  border-radius: 8px;\n  color: #991b1b;\n  font-size: 13px;\n  line-height: 1.5;\n}\n\n/* 参考图片网格展示 */\n.Sora2VideoNode-image-grid {\n  display: grid;\n  grid-template-columns: repeat(4, 1fr);\n  gap: 8px;\n  margin-top: 8px;\n}\n\n.Sora2VideoNode-image-thumb {\n  position: relative;\n  aspect-ratio: 1;\n  border-radius: 6px;\n  overflow: hidden;\n  border: 2px solid #e5e7eb;\n  transition: all 0.2s;\n  background: #f9fafb;\n}\n\n.Sora2VideoNode-image-thumb:hover {\n  border-color: #8b5cf6;\n  transform: scale(1.05);\n  z-index: 10;\n}\n\n.Sora2VideoNode-image-inactive {\n  opacity: 0.4;\n  filter: grayscale(0.5);\n}\n\n.Sora2VideoNode-thumb-img {\n  width: 100%;\n  height: 100%;\n  object-fit: cover;\n  display: block;\n}\n\n.Sora2VideoNode-thumb-index {\n  position: absolute;\n  top: 4px;\n  right: 4px;\n  background: rgba(139, 92, 246, 0.9);\n  color: white;\n  width: 20px;\n  height: 20px;\n  border-radius: 50%;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  font-size: 10px;\n  font-weight: 600;\n}\n\n.Sora2VideoNode-thumb-active-badge {\n  position: absolute;\n  bottom: 4px;\n  left: 4px;\n  background: rgba(16, 185, 129, 0.95);\n  color: white;\n  padding: 2px 6px;\n  border-radius: 4px;\n  font-size: 10px;\n  font-weight: 600;\n}\n\n/* 警告提示 */\n.Sora2VideoNode-warning {\n  margin-top: 8px;\n  padding: 8px;\n  background-color: #fef3c7;\n  border: 1px solid #fbbf24;\n  border-radius: 6px;\n  font-size: 11px;\n  color: #78350f;\n  line-height: 1.4;\n}\n\n/* 复制按钮样式 */\n.Sora2VideoNode-duplicate-button {\n  position: absolute;\n  top: 8px;\n  right: 8px;\n  width: 28px;\n  height: 28px;\n  border: 1px solid #ddd;\n  border-radius: 6px;\n  background: white;\n  color: #666;\n  cursor: pointer;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  font-size: 14px;\n  transition: all 0.2s ease;\n  opacity: 0;\n  pointer-events: none;\n  z-index: 10;\n  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);\n}\n\n.Sora2VideoNode-container:hover .Sora2VideoNode-duplicate-button {\n  opacity: 1;\n  pointer-events: auto;\n}\n\n.Sora2VideoNode-duplicate-button:hover {\n  background: #f0f0f0;\n  border-color: #3b82f6;\n  color: #3b82f6;\n  transform: scale(1.05);\n}\n\n.Sora2VideoNode-duplicate-button:active {\n  transform: scale(0.95);\n}\n\n.react-flow__node.selected .Sora2VideoNode-duplicate-button {\n  opacity: 1;\n  pointer-events: auto;\n}\n\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
